'use client';

import { LockedModule } from '../_components/LockedModule';

export default function RemindersPage() {
  return (
    <LockedModule
      tier="Pro"
      title="תזכורות אוטומטיות ללקוחות"
      description="שלחו תזכורות SMS אוטומטיות לפני כל תור ומנעו אי-הגעות. זמין בתוכנית Pro."
    />
  );
}
